const getApiBaseUrl = () => {
    const hostname = window.location.hostname;
    
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return 'http://localhost/leo/api';
    } else if (hostname === 'leo.sudeshmaths.com') {
        return 'https://leo.sudeshmaths.com/api';
    } else {
        return 'https://myclub.sliitleo.org/api';
    }
};

export const API_BASE_URL = getApiBaseUrl();
